<!-- FT-216 REQ-02, REQ-15: настройки машины в динамическом ценообразовании — «Участвует», мин. и макс.
     цена за сутки. Свёрнутая панель под таблицами цен вкладки «Цены» карточки машины, своё сохранение
     (PATCH /api/v1/cars/:id/dynamic_pricing, вне общей кнопки сохранения машины). Без услуги в плане и
     без блока dynamic_pricing в car_card_data (не superadmin/admin) панели нет. -->
<template>
  <v-expansion-panels v-if="visible" v-model="open" flat class="mt-4" data-testid="car-dp-panel">
    <v-expansion-panel>
      <v-expansion-panel-header data-testid="car-dp-header">
        <span>
          <v-icon small class="mr-1">mdi-chart-line-variant</v-icon>{{ $t("dynamic_pricing.title") }}<BetaChip />
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-switch v-model="participates" :label="$t('dynamic_pricing.car_participates')" dense hide-details
          class="mt-0 mb-3" data-testid="car-dp-participates" />
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field v-model="minText" type="number" min="0" dense outlined clearable
              :label="$t('dynamic_pricing.car_min_day_price')" :hint="$t('dynamic_pricing.car_bounds_hint')" persistent-hint
              :error-messages="boundsError" data-testid="car-dp-min" />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field v-model="maxText" type="number" min="0" dense outlined clearable
              :label="$t('dynamic_pricing.car_max_day_price')" :hint="$t('dynamic_pricing.car_bounds_hint')" persistent-hint
              data-testid="car-dp-max" />
          </v-col>
        </v-row>
        <v-btn color="success" small class="mt-3" :loading="saving" :disabled="!canSave" data-testid="car-dp-save"
          @click="save">
          <!-- явная подпись: ниже карточки своя большая «Сохранить» (машина), эта сохраняет только панель -->
          {{ $t("dynamic_pricing.car_save") }}
        </v-btn>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import {
  carDynamicPricingState,
  dynamicPricingApi,
  dynamicPricingInPlan,
  parseDynamicPricingError,
} from "@/api/dynamicPricing";

// "" / null / undefined — граница не задана (границы компании); иначе число ≥ 0 или NaN (невалидно).
export function parseBound(text) {
  if (text === "" || text == null) return null;
  const n = Number(text);
  return Number.isFinite(n) && n >= 0 ? n : NaN;
}

const toText = (value) => (value == null ? "" : String(value));

export default {
  name: "CarPricingLimitsPanel",
  props: {
    carId: { type: [Number, String], required: true },
    // { participates, min_day_price, max_day_price } из car_card_data; null — блока нет
    state: { type: Object, default: null },
  },
  data() {
    return {
      open: undefined,
      participates: true,
      minText: "",
      maxText: "",
      saving: false,
    };
  },
  computed: {
    // REQ-15: панель скрыта без услуги в плане; api блок отдаёт только superadmin/admin.
    visible() {
      return !!this.state && !!this.isAdminPlus && dynamicPricingInPlan(this.$store && this.$store.getters.getMainCompany);
    },
    min() {
      return parseBound(this.minText);
    },
    max() {
      return parseBound(this.maxText);
    },
    boundsError() {
      return Number.isNaN(this.min) || Number.isNaN(this.max) || (this.min != null && this.max != null && this.min > this.max)
        ? this.$t("dynamic_pricing.car_bounds_invalid")
        : "";
    },
    dirty() {
      const s = this.state || {};
      return (
        this.participates !== (s.participates !== false) ||
        toText(this.min) !== toText(s.min_day_price == null ? null : Number(s.min_day_price)) ||
        toText(this.max) !== toText(s.max_day_price == null ? null : Number(s.max_day_price))
      );
    },
    canSave() {
      return !this.saving && this.dirty && !this.boundsError;
    },
  },
  watch: {
    state: {
      immediate: true,
      handler(state) {
        const s = state || {};
        this.participates = s.participates !== false;
        this.minText = toText(s.min_day_price);
        this.maxText = toText(s.max_day_price);
      },
    },
  },
  methods: {
    async save() {
      if (!this.canSave) return;
      this.saving = true;
      const body = { participates: this.participates, min_day_price: this.min, max_day_price: this.max };
      try {
        const data = await dynamicPricingApi.updateCarSettings(this.axios, this.carId, body);
        const fresh = data && typeof data.participates === "boolean" ? data : body;
        this.$emit("update:state", carDynamicPricingState(fresh));
        this.$notify && this.$notify(this.$t("custom.updated"), "", "success");
      } catch (error) {
        const parsed = parseDynamicPricingError(error);
        if (parsed) {
          this.$notify && this.$notify(this.$t("dynamic_pricing.car_save_error"), this.$t(parsed.i18nKey), "warning", 6000);
        } else {
          this.setError && this.setError(error, this.$t("dynamic_pricing.car_save_error"));
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
